/**
 * Tool Keys Constants
 * 
 * Canonical tool key definitions and normalization helpers for ScoutsDesk tools.
 */

export const TOOL_KEYS = /** @type {const} */ ([
  "chat",
  "quizzes",
  "flashcards",
  "podcasts",
  "audiobooks",
  "key_terms",
  "tts",
]);

export const TOOL_KEY_SET = new Set(TOOL_KEYS);

/**
 * Migration map for backward compatibility with PascalCase tool names
 */
export const TOOL_KEY_MIGRATION = {
  Quizzes: "quizzes",
  Flashcards: "flashcards",
  Podcasts: "podcasts",
  Audiobooks: "audiobooks",
  KeyTerms: "key_terms",
  keyTerms: "key_terms",
  "Key Terms": "key_terms",
  TTS: "tts",
  Tts: "tts",
  TextToSpeech: "tts",
  text_to_speech: "tts",
  "text-to-speech": "tts",
  null: "chat",
  undefined: "chat",
};

/**
 * Normalize tool key to canonical lowercase format
 * @param {string|null|undefined} toolKey - Tool key to normalize
 * @returns {string} Normalized tool key (defaults to "chat" for falsy values)
 */
export function normalizeToolKey(toolKey) {
  if (!toolKey) return "chat";
  
  // Check migration map first
  if (TOOL_KEY_MIGRATION[toolKey]) {
    return TOOL_KEY_MIGRATION[toolKey];
  }
  
  // Fallback to lowercase
  return String(toolKey).toLowerCase();
}
